module.exports = __webpack_public_path__ + "752ba3b10545178c77ab6c193c553e50.MP3";